import script from "./date.vue?vue&type=script&setup=true&lang=ts"
export * from "./date.vue?vue&type=script&setup=true&lang=ts"

import "./date.vue?vue&type=style&index=0&id=2b7eed08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7eed08"]])

export default __exports__